import React from 'react';
import { EyeIcon, RouteIcon, BookOpenIcon, TrendingUpIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = [RouteIcon, BookOpenIcon, EyeIcon, TrendingUpIcon];
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-ink" data-id="element-16" data-mp="3npb4tilqeuhn">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3nnq8bnfux1h5">
        <h2 id="beneficios" className="font-display text-[1.5rem] font-extrabold leading-[1.1] tracking-tight text-white sm:text-4xl" data-id="element-18" data-mp="38qz8jd29tnr0">
          ¿Qué puede cambiar cuando{' '}
          <span className="text-highlight" data-id="element-19" data-mp="2zsdrxngd0isv">empezás?</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-20" data-mp="34px7qrsph3mx">
          Una habilidad práctica puede abrir nuevas posibilidades.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-21" data-mp="xxwejotw8t0c">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[i];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-success bg-white p-2.5 text-left" data-id="element-22" data-mp="2be49brllvf5s" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-success text-white" aria-hidden="true" data-id="element-23" data-mp="2l73a07udmw5r">
                  <Icon size={16} data-id="element-24" data-mp="1sgl7b7xkewsv" />
                </span>
                <div data-id="element-25" data-mp="1ofhrglfip0rn">
                  <h3 className="font-sub text-sm font-semibold leading-tight text-brand" data-id="element-26" data-mp="1ogarz4nvuu1c">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-ink/80 sm:text-sm" data-id="element-27" data-mp="1xfo4k67azyqa">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}